import { logoSliderInit } from '../components/logoSlider'
import './../../scss/blocks/_logoslider.scss'

document.addEventListener('DOMContentLoaded', () => {
    const sliderSections = document.querySelectorAll('.logo-slider-section')

    sliderSections.forEach((section) => {
        const slider = section.querySelector('.swiper.logo-slider')
        const arrowNext = section.querySelector('.logo-slider-next')
        const arrowPrev = section.querySelector('.logo-slider-prev')
        logoSliderInit(slider, arrowNext, arrowPrev)
    })
})
